/* ==========================================================================
   ZOIS US CV - PDP Refinements
   Verschiebt den Duft-Guide-Trigger in die Kopfzeile von Schritt 2 des
   Bundle-Builders ("Build your set").

   Bewusst als Verschiebung im DOM, nicht als Neuaufbau: der Block
   zois_duftguide bleibt samt Popup vollstaendig im Theme erhalten. Findet
   das Skript keinen Bundle-Builder - anderer Shop, anderer Aufbau, Block
   entfernt - bleibt der Trigger an seiner urspruenglichen Stelle stehen.
   Event-Listener ueberleben das Verschieben, das Popup funktioniert weiter.
   ========================================================================== */

(function () {
  function findStepTwoHead() {
    var cardsHead = document.querySelector('.zois-bb--cards .zois-bb__stephead');
    if (cardsHead) return cardsHead;
    var heads = document.querySelectorAll('.zois-bb__stephead');
    for (var i = 0; i < heads.length; i++) {
      var num = heads[i].querySelector('.zois-bb__stepnum');
      if (num && num.textContent.trim() === '2') return heads[i];
    }
    return null;
  }

  function moveGuide() {
    var trigger = document.querySelector('.zois-dg-trigger');
    if (!trigger) return;

    var head = findStepTwoHead();
    if (!head) return;
    if (head.contains(trigger)) return;

    var wrap = trigger.parentElement;
    head.appendChild(trigger);

    // Der zurueckbleibende Wrapper enthaelt weiterhin das <dialog>.
    // Dialoge sind geschlossen display:none, es bleibt nur der Blockabstand.
    if (wrap && wrap.querySelector('.zois-dg-modal')) {
      wrap.classList.add('zois-dg-wrap--moved');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveGuide, { once: true });
  } else {
    moveGuide();
  }

  // Theme-Editor: Blocks werden beim Bearbeiten neu gerendert
  document.addEventListener('shopify:section:load', moveGuide);
  document.addEventListener('shopify:block:select', moveGuide);
})();

/* ==========================================================================
   Intelligems-Preistest "Preisstaffel Herren 79/139/199 vs 59/118/177"
   Nur auf /products/invisible-code-collection.

   Die Stufenpreise im Bundle-Builder sind im Theme-Editor fest hinterlegt
   (59 / 118 / 177) und werden von Intelligems nicht automatisch ersetzt.
   Dieser Block fragt ueber die Intelligems-JS-API den Preis der Einzel-
   flasche ab. Liegt er bei 79 USD (Testgruppe), werden die Stufen auf
   79 / 139 / 199 gesetzt und der Builder neu gerendert. Fuer alle anderen
   Besucher (Control, kein Test aktiv) aendert sich nichts.

   Nach Testende diesen Block wieder entfernen.
   ========================================================================== */

(function () {
  var path = window.location.pathname.replace(/\/+$/, '');
  if (path !== '/products/invisible-code-collection') return;

  // Einzelpreis der Testgruppe in Cent -> Stufenpreise je Flaschenanzahl in Cent
  var TIER_MAP = {
    '7900': { '1': 7900, '3': 13900, '5': 19900 }
  };
  var tries = 0;

  function igPriceCents(variantId) {
    var api = window.igData && window.igData.price;
    if (!api || typeof api.getPriceByVariantId !== 'function' || !variantId) return null;
    var p = api.getPriceByVariantId(Number(variantId));
    if (p == null || p === '') p = api.getPriceByVariantId(String(variantId));
    if (p == null || p === '') return null;
    var n = Math.round(parseFloat(p) * 100);
    return isFinite(n) ? n : null;
  }

  // true = fertig (oder nichts zu tun), false = spaeter nochmal versuchen
  function apply() {
    try {
      if (!window.igData || !window.igData.price) return false;
      var roots = document.querySelectorAll('[data-zois-bb]');
      if (!roots.length) return false;
      var done = true;
      Array.prototype.forEach.call(roots, function (root) {
        if (root.getAttribute('data-ig-applied') === '1') return;
        if (!root.__bb) { done = false; return; }
        var frag = root.querySelector('[data-frag][data-variant]');
        var cents = frag ? igPriceCents(frag.getAttribute('data-variant')) : null;
        var map = cents != null ? TIER_MAP[String(cents)] : null;
        root.setAttribute('data-ig-applied', '1');
        if (!map) return;
        Array.prototype.forEach.call(root.querySelectorAll('.zois-bb__tier'), function (t) {
          var v = map[t.getAttribute('data-slots')];
          if (v != null) t.setAttribute('data-price-cents', String(v));
        });
        // Aktuelle Stufe erneut auswaehlen -> Builder rendert Preise neu,
        // gewaehlte Duefte bleiben erhalten.
        var sel = root.querySelector('.zois-bb__tier[aria-pressed="true"]') || root.querySelector('.zois-bb__tier');
        if (sel) sel.click();
      });
      return done;
    } catch (e) {
      return true;
    }
  }

  function run() {
    if (apply()) return;
    tries++;
    if (tries < 60) setTimeout(run, 100);
  }

  window.addEventListener('ig:ready', function () { tries = 0; run(); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
